/**
 * 解决方案分类相关纯函数：标题文案生成与分类标识解析。
 *
 * 对应设计文档 Correctness Properties:
 * - Property 2: 分类数量标题文案生成（Requirements 6.3, 6.4）
 * - Property 4: 分类标识兼容解析（Requirements 7.12, 8.1, 8.3, 8.6）
 */

/** 按 sort 排序的四个生效分类标识，供列表页与导航复用 */
export const ACTIVE_CATEGORY_SET = [
  "info-security",
  "it-infrastructure",
  "cloud-xinda",
  "ai-business",
] as const;

const CN_NUM = ["", "一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];

/**
 * 依据分类数量生成 Nav_Dropdown / Solutions_Page 的标题文案。
 * 1 <= count <= 10 时返回「{中文数量词}大核心解决方案」，否则返回「核心解决方案」。
 */
export function buildSolutionsTitle(count: number): string {
  if (Number.isInteger(count) && count >= 1 && count <= 10) {
    return `${CN_NUM[count]}大核心解决方案`;
  }
  return "核心解决方案";
}

/**
 * 解析 URL 中候选分类标识为最终生效的激活分类标识：
 * - 属于 activeCategorySet 时原样返回
 * - 等于 legacyId（默认 "intelligent-building"）时返回 mergedTargetId（默认 "it-infrastructure"）
 * - 其余情况（含 null/undefined/任意其他字符串）返回 defaultId（默认 "info-security"）
 */
export function resolveActiveCategory(
  param: string | null | undefined,
  activeCategorySet: readonly string[],
  legacyId = "intelligent-building",
  mergedTargetId = "it-infrastructure",
  defaultId = "info-security",
): string {
  if (param && activeCategorySet.includes(param)) return param;
  if (param === legacyId) return mergedTargetId;
  return defaultId;
}
